// extracted by mini-css-extract-plugin
export default {"modal":"modal__UgFj_","content":"content__b0RoF","content__iframe":"content__iframe__Rj4xA","content__loader":"content__loader__AYy04"};